interface ITrackEventProps {
  category: string,
  action: string,
  label: string,
  value: number | null
}

/**
 * FUTURE SELF
 * This used to call trackCustomEvent from gatsby-plugin-google-analytics, which
 * sent events to the Universal Analytics property. UA stopped processing data in
 * July 2023, so that plugin was removed and these events now go to the GTM
 * dataLayer instead. GTM is what loads GA4 on this site.
 *
 * NOTE: a "customEvent" trigger has to exist in the GTM container, forwarding to
 * the GA4 tag, or these pushes sit in the dataLayer and go nowhere.
 */
const trackEvent = (event: ITrackEventProps) => {
  if (!event) return null

  // No window during SSR / build.
  if (typeof window === "undefined") return null

  const dataLayer = (window as any).dataLayer

  // GTM hasn't loaded, which is also the case when cookies have been declined.
  if (!Array.isArray(dataLayer)) return null

  dataLayer.push({
    event: "customEvent",
    eventCategory: event?.category ?? "link",
    eventAction: event?.action ?? "click",
    eventLabel: event?.label ?? "undefined",
    eventValue: event?.value ?? 0,
  })
}

export default trackEvent
